<section class="tile">
  @if (title()) {
    <div class="tile__header" [ngClass]="'tile__header--' + headerSpacing()">
      <div class="tile__heading">
        <h2 class="tile__title">{{ title() }}</h2>
        @if (rightText()) {
          <span class="tile__right-text">{{ rightText() }}</span>
        }
      </div>
      <div class="tile__actions">
        <ng-content select="[tile-actions]"></ng-content>
      </div>
    </div>
  }
  <ng-content></ng-content>
</section>
